import { __assign, __rest } from "tslib";
import React from 'react';
import { CnTooltip } from '@cainiaofe/cn-ui';
export var CnPopover = function (props) {
    var children = props.children, content = props.content, placement = props.placement, rest = __rest(props, ["children", "content", "placement"]);
    var alignMap = {
        left: 'l',
        top: 't',
        right: 'r',
        bottom: 'b',
        'left-end': 'lb',
        'left-start': 'lt',
        'top-end': 'tr',
        'top-start': 'tl',
        'right-end': 'rb',
        'right-start': 'rt',
        'bottom-end': 'br',
        'bottom-start': 'bl',
    };
    var mapProps = {};
    if (placement) {
        Object.assign(mapProps, { align: alignMap[placement] });
    }
    return (React.createElement(CnTooltip, __assign({ v2: true }, rest, mapProps, { trigger: children }), content));
};
